import axios from 'axios';
import { getAccessToken } from '../utils/storage';
// eslint-disable-next-line no-undef
import { baseUrl } from '../constants';
import { responseInterceptor } from './responseInterceptor';

const pending = new Map(); //  Request object
const CancelToken = axios.CancelToken;

export const axiosInstance = axios.create({
    baseURL: baseUrl,
    timeout: 60 * 4 * 1000
});

axiosInstance.interceptors.request.use(
    (config) => {
        if (getAccessToken()) {
            const token = 'Bearer ' + getAccessToken();
            config.headers.Authorization = token;
        }
        removePending(config); // check and cancel duplicate request
        addPending(config); // add the current request to pending

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axiosInstance.interceptors.response.use(
    (response) => {
        removePending(response.config);
        return response;
    },
    (error) => {
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        } else {
            removePending(error.config);
            return responseInterceptor(error, axiosInstance);
        }
    }
);
export const Get = (url, config) => axiosInstance.get(url, config);
export const Post = (url, data, config) => axiosInstance.post(url, data, config);
export const Put = (url, data, config) => axiosInstance.put(url, data, config);
export const Patch = (url, data, config) => axiosInstance.patch(url, data, config);
export const Delete = (url, config) => axiosInstance.delete(url, config);

const addPending = (config) => {
    const url = [config.method, config.url].join('&');
    config.cancelToken = new CancelToken(function executor(cancel) {
        pending.set(url, cancel);
    });
};
const removePending = (config) => {
    const url = [config?.method, config?.url].join('&');
    if (pending.has(url)) {
        const cancel = pending.get(url);
        cancel(url);
        pending.delete(url);
    }
};
